import { ReactNodeViewRenderer } from "@tiptap/react";
import Image from "@tiptap/extension-image";
import { ImageView } from "./ImageView";

export const ImageNode = Image.extend({
  inline: true,
  group: "inline",
  draggable: true,

  addAttributes() {
    return {
      ...this.parent?.(),
      src: { default: null },
      alt: { default: null },
      width: { default: "auto" },
      height: { default: "auto" },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageView);
  },
});
